/**
 * Subscription dialog
 *
 * @package EBNewsletters
 */

const SELECTOR = {
	dialog: '.modal',
	state: '.modal__state',
	icon: '[data-field="icon"]',
	email: '.modal__email',
	form: '[data-signup-form]',
	close: '[data-modal-close]',
	recommendations: '.recommendations',
	list: '.recommendations__list',
	template: '#recommendation-row-template',
};

const dialog = () => document.querySelector(SELECTOR.dialog);

let pageScroll = 0;

const icons = new Map();

export const preloadIcons = data => {
	const slot = dialog()?.querySelector(SELECTOR.icon);

	Object.values(data).forEach(entry => {
		[entry, ...entry.recommendations].forEach(({ icon }) => {
			if (slot && !icons.has(icon)) {
				const img = slot.cloneNode();
				img.src = icon;
				icons.set(icon, img);
			}
		});
	});
};

export const setState = state => {
	const el = dialog();
	el.dataset.state = state;
	el.querySelectorAll(SELECTOR.state).forEach(panel => {
		panel.hidden = panel.dataset.state !== state;
	});
	el.querySelector(SELECTOR.recommendations).hidden =
		state !== 'success' || !el.querySelector(SELECTOR.list).children.length;
};

export const open = (entry, email) => {
	const el = dialog();

	el.querySelector(SELECTOR.list).replaceChildren();

	const icon = icons.get(entry.icon);

	if (icon) {
		el.querySelector(SELECTOR.icon).replaceWith(icon);
	}

	el.querySelectorAll('[data-field="title"]').forEach(node => {
		node.textContent = entry.title;
	});

	el.querySelector(SELECTOR.email).value = email;
	el.dataset.knownEmail = String(Boolean(email));

	setState('form');

	pageScroll = window.scrollY;
	el.showModal();
	window.scrollTo(0, pageScroll);
};

export const renderRecommendations = (entries, onSignup) => {
	const template = document.querySelector(SELECTOR.template);
	const list = dialog().querySelector(SELECTOR.list);

	entries.forEach(entry => {
		const row = template.content
			.cloneNode(true)
			.querySelector('.recommendation-row');
		row.dataset.newsletter = entry.id;
		row.querySelector('[data-field="icon"]').src = entry.icon;
		row.querySelector('[data-field="title"]').textContent = entry.title;
		row.querySelector('[data-field="description"]').textContent =
			entry.description;
		row.querySelector('[data-signup]').addEventListener('click', () => {
			onSignup(entry, row);
		});
		list.append(row);
	});
};

export const initModal = onSubmit => {
	const el = dialog();
	if (!el) {
		return;
	}

	el.querySelector(SELECTOR.close).addEventListener('click', () => el.close());

	el.addEventListener('close', () => window.scrollTo(0, pageScroll));

	el.addEventListener('click', event => {
		if (event.target === el) {
			el.close();
		}
	});

	el.querySelector(SELECTOR.form).addEventListener('submit', event => {
		event.preventDefault();
		onSubmit(el.querySelector(SELECTOR.email).value.trim());
	});
};
